export function shouldVerifyWechatSession(data) {
  const status = data && data.status ? data.status : "waiting";
  return status === "confirmed" || status === "redeemed";
}

export function isVerifiedWechatLogin(data, session) {
  const stateUserID = data && data.user && typeof data.user.id === "string"
    ? data.user.id.trim()
    : "";
  const sessionUserID = session && session.user && typeof session.user.id === "string"
    ? session.user.id.trim()
    : "";
  return shouldVerifyWechatSession(data)
    && stateUserID !== ""
    && stateUserID === sessionUserID;
}

export function createWechatPollGuard() {
  let generation = 0;
  let activeRequest = null;

  return {
    invalidate() {
      generation += 1;
      if (activeRequest && activeRequest.controller) {
        activeRequest.controller.abort();
      }
      activeRequest = null;
      return generation;
    },
    isCurrent(candidate) {
      return candidate === generation;
    },
    current() {
      return generation;
    },
    beginRequest(candidate) {
      if (candidate !== generation || activeRequest) {
        return null;
      }
      const controller = typeof AbortController === "function"
        ? new AbortController()
        : null;
      const request = {
        controller,
        signal: controller ? controller.signal : undefined,
        finish() {
          if (activeRequest === request) {
            activeRequest = null;
          }
        },
      };
      activeRequest = request;
      return request;
    },
  };
}
